module.exports = __webpack_public_path__ + "static/img/ic_bottom_heart_on@2x.bdd9c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_heart_on@2x.png
// module id = PD7C
// module chunks = 1